import { RecoverPasswordPage } from '@pages/recoverPassword';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Восстановление пароля', 'Восстановление пароля');
}

export default function Page() {
  return <RecoverPasswordPage />;
}
